import { createIcon } from '../createIcon';
import { ReactComponent as IconUserAlt } from '../svg/user-alt.svg';

export default createIcon(IconUserAlt);
